import { Disclaimer, Div } from '@vgrubs/components';

type Props = {
  children: React.ReactNode;
};

/**
 * A column's name before its value ("Bank: Connected"), on phones only. The lists here are a
 * TableHeader over rows on desktop, but the header is desktop-only, and a
 * stacked "Connected" or "$0.00" means nothing without it.
 */
export const MobileLabel = ({ children }: Props) => (
  // Never wraps or shrinks: the value beside it is the part that gives way.
  <Div $mobile style={{ flex: 'none' }}>
    <Disclaimer $m="0" style={{ whiteSpace: 'nowrap' }}>
      {children}:
    </Disclaimer>
  </Div>
);
